import { Messages } from "./event-messages.constants";

export class RightshipQiMessages extends Messages {
    public static paste: string = "onPaste";
    public static viewCorrespondenceTab: string = "viewCorrespondenceTab";
}
